<template>
  <v-app >
    <Navbar />
    <v-btn flat v-if="this.$device.mobile&&auth"  color="error" @click="logout"><img src="/img/logout.png" class="mr-1"  width="30" alt="logout " style="display:inline;"> <span>Deconnecter</span></v-btn>
    <v-content>
    <transition name="view">
      <router-view />
    </transition>
    </v-content>
     <BottomNav />
  </v-app>
</template>
<script>
import Navbar from './components/Navbar'
import BottomNav from './components/BottomNav'
import firebase from './fb'
import { mapGetters} from "vuex";

export default {
  name: 'App',
  components: {
    Navbar,
    BottomNav
  },
  data () {
    return {
      pwa:false,
      refreshing: false,
      registration: null,
      updateExists: false,
    }

  },
  computed: {
    ...mapGetters("authfb", ["user", "auth"])
  },

  created () {
    
    // Listen for swUpdated event and display refresh snackbar as required.
    document.addEventListener('swUpdated', this.showRefreshUI, { once: true });
    // Refresh all open app tabs when a new service worker is installed.
    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (this.refreshing) return;
        this.refreshing = true;
        window.location.reload();
      });
    }
  },

  mounted () {
    console.log('helllo device');
    
    const standalone= ()=> (window.matchMedia('(display-mode: standalone)').matches);
    this.pwa=standalone()

    window.addEventListener('popstate', (event)=>{
    // The popstate event is fired each time when the current history entry changes.
     if (standalone()) {
       swal({
          title: "Fermer?",
          text: '',
          icon: "warning",
          buttons: true,
          dangerMode: true,
        })
        .then((willDelete) => {
          if (willDelete) {
            this.logout()
          } else {
            history.pushState(null, null, window.location.pathname);
          }
          });
     }
}, false);

  },

  methods: {
    logout() {
    swal({
          title: "Deconnecter?",
          text: 'Vous etes sur le point de vous deconncecter',
          icon: "warning",
          buttons: true,
          dangerMode: true,
        })
        .then((willDelete) => {
          if (willDelete) {
            firebase.auth().signOut().then( ()=>{
            this.$router.push('/login')
            window.location.reload()
      // Sign-out successful.
    }).catch( (error)=>{
      console.log(error);
      
      // An error happened.
    });
          }
          });
    },

    showRefreshUI (e) {
      // Display a button inviting the user to refresh/reload the app due
      // to an app update being available.
      // The new service worker is installed, but not yet active.
      // Store the ServiceWorkerRegistration instance for later use.
      this.registration = e.detail;
      this.updateExists = true;
    },
    refreshApp () {
      // Handle a user tap on the update app button.
      this.updateExists = false;
      // Protect against missing registration.waiting.
      if (!this.registration || !this.registration.waiting) { return; }
      this.registration.waiting.postMessage('skipWaiting');
    }

  },
}
</script>

<style>
  .view-enter-active, .view-leave-active {
  transition: opacity 0.2s ease-in-out, transform 0.2s ease;
}

.view-enter-active {
  transition-delay: 0.2s;
}

.view-enter {
  opacity: 0.3;
  
}
.view-enter-to {
  opacity: 1;
 
}
.view-leave {
  opacity: 1;
  
}

.view-leave-to {
  opacity: 1;
  
}

</style>